export const DENSE_PAGE_DEFAULT_PAGE_SIZE = 25;

export const DENSE_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
